<template>
  <div>
    <div
      class="breadcrumb-area pos-relative w-100"
      v-if="dataPermission.includes('CNPS_DEVICE_VIEW')"
    >
      <h1>Chi tiết Thiết bị</h1>
      <div class="btn-group float-right">
        <button
          v-if="
            dataPermission.includes('CNPS_DEVICE_ORDER_EXPORT_LOSS') &&
            ['AVAILABILITY', 'USED'].includes(detail.status)
          "
          class="f12 font-medium btn btn-outline-secondary"
          @click="reportLossDevice"
        >
          Báo thất lạc TB
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
        <!-- <button
          class="f12 font-medium btn btn-outline-secondary"
          v-if="detail.type === 'ERROR' && dataPermission.includes('CNPS_DEVICE_CONFIRM_WARRANTY_SUCCESS') && [detail.keeper && detail.keeper.email, detail.manager && detail.manager.email].includes(dataUser.username)"
          @click="warrantySuccess()">
          <i class="bx bx-pencil"></i> Bảo hành thành công
        </button> -->
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="form-detail">
                  <h1>1. Thông tin thiết bị</h1>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Tên thiết bị<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.categoryName }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Mã Serial<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.serial }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Kho đang quản lý<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.inventoryName }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Mã thùng<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.numberGear }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Tình trạng<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        <span class="badge" :class="[detail.type ? detail.type : '']">
                          {{ detail.type | transformData(optionState) }}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Trạng thái<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        <span class="badge" :class="[detail.status ? detail.status : '']">
                          {{ detail.status | transformData(optionStatus) }}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Trạng thái/Mã đơn Boxme<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        <span
                          class="badge"
                          :class="transformColor(detail.statusBoxme, Config.statusBoxme)"
                        >
                          {{ detail.statusBoxme | transformData(Config.statusBoxme) }}
                        </span>
                        <span> / Mã đơn: {{ detail.trackingNumber || '' }} </span>
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Thủ kho<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.keeper && detail.keeper.name }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Số HĐ/PL<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.contractCode }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Ghi chú<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.description }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-sm-6">
                </div> -->
              </div>
              <div class="form-row">
                <div class="form-detail">
                  <div class="d-flex justify-content-between">
                    <h1>2. Lịch sử luân chuyển</h1>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table table-hover table-bordered"
                      style="max-height: 400px; overflow-y: auto"
                    >
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" class="text-center">Thời gian</th>
                          <th scope="col" class="text-center">Loại</th>
                          <th scope="col" class="text-center">Lý do</th>
                          <th scope="col" class="text-center">Số phiếu</th>
                          <th scope="col" class="text-center">Trạng thái</th>
                          <th scope="col" class="text-center">Tên kho nhập</th>
                          <th scope="col" class="text-center">Tên kho xuất</th>
                          <th scope="col" class="text-center">Người tạo</th>
                          <th scope="col" class="text-center">Người duyệt</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="table-row"
                          v-for="(item, index) in detail.infoDeviceHistories"
                          :key="index"
                        >
                          <td class="text-center">
                            {{ item.dateCreate | formatDate('HH:mm DD/MM/YYYY') }}
                          </td>
                          <td class="text-center">
                            {{
                              item.type === 'TRANSFER' && item.reason === 'TRANSFER_AGENCY'
                                ? 'Điều chuyển đại lý'
                                : item.type | transformData(optionTypeBill)
                            }}
                          </td>
                          <td class="text-center">
                            {{
                              item.type === 'TRANSFER' && item.reason === 'TRANSFER_AGENCY'
                                ? ''
                                : item.reason | transformData(optionReason)
                            }}
                          </td>
                          <td class="text-center">
                            <span @click="changeLink(item)" class="cursor text-primary"
                              >{{ item.billNumber }} (chi tiết)</span
                            >
                          </td>
                          <td class="text-center">
                            <span class="badge" :class="[item.status ? item.status : '']">
                              {{ item.status | transformData(optionStatusHis) }}
                            </span>
                          </td>
                          <td class="text-center">
                            {{ item.inventoryNameImport }}
                          </td>
                          <td class="text-center">
                            {{ item.inventoryNameExport }}
                          </td>
                          <td class="text-center">
                            {{ item.userCreator.name }}<br />
                            <p class="text-primary text-center">
                              {{ item.userCreator.email }}
                            </p>
                          </td>
                          <td class="text-center">
                            {{ item.personApprove.name }}<br />
                            <p class="text-primary text-center">
                              {{ item.personApprove.email }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-detail">
                  <div class="d-flex justify-content-between">
                    <h1>3. Lịch sử bảo hành thiết bị</h1>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table table-hover table-bordered"
                      style="max-height: 400px; overflow-y: auto"
                    >
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" class="text-center">Thời gian</th>
                          <th scope="col" class="text-center">Số phiếu</th>
                          <th scope="col" class="text-center">Thiết bị</th>
                          <th scope="col" class="text-center">Kho</th>
                          <th scope="col" class="text-center">Người tạo</th>
                          <th scope="col" class="text-center">Vùng</th>
                          <th scope="col" class="text-center">Loại lỗi</th>
                          <th scope="col" class="text-center">Đối tượng gây lỗi</th>
                          <th scope="col" class="text-center">Trạng thái</th>
                          <th scope="col" class="text-center">Hành động</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="table-row"
                          v-for="(item, index) in detail.logWarrantyRes"
                          :key="index"
                        >
                          <td class="text-center">
                            <span>Tạo: {{ item.createTime | formatDate('HH:mm DD/MM/YYYY') }}</span
                            ><br />
                            <span
                              >Duyệt: {{ item.approvedTime | formatDate('HH:mm DD/MM/YYYY') }}</span
                            >
                          </td>
                          <td class="text-center">
                            {{ item.code }}
                          </td>
                          <td class="text-center">
                            <span>{{ item.deviceError.name }}</span> <br />
                            <span>{{ item.deviceError.serial }}</span> <br />
                            <span class="badge SUCCESS">{{
                              item.deviceError.typeError | transformData(Config.stateDevices)
                            }}</span>
                          </td>
                          <td class="text-center">
                            <span>Tạo: {{ item.initInventoryName }}</span
                            ><br />
                            <span>Đang xử lý: {{ item.processingInventoryName }}</span>
                          </td>
                          <td class="text-center">
                            {{ item.creator ? item.creator.name : '' }}
                          </td>
                          <td class="text-center">
                            {{ item.regionNames.join(', ') }}
                          </td>
                          <td class="text-center">
                            {{ item.deviceError.errors.join(', ') }}
                          </td>
                          <td class="text-center">
                            {{ item.deviceError.reason | transformData(Config.faultMaker) }}
                          </td>
                          <td class="text-center">
                            <span class="badge" :class="item.status">
                              {{ item.status | transformData(Config.statusWarranty) }}
                            </span>
                            <span v-if="item.reasonReject"> {{ item.reasonReject }}</span>
                          </td>
                          <td class="text-center">
                            <b-dropdown class="text-center" variant="outline-light">
                              <b-dropdown-item
                                class="dropdown-item"
                                @click="detailWarranty(item.id)"
                                ><span>&nbsp;</span>Chi tiết
                              </b-dropdown-item>
                            </b-dropdown>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import Config from '../../../thirdParty/config'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        showLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
        id: this.$route.params.id,
        detail: {},
        optionStatus: Config.statusDevices,
        optionState: Config.stateDevices,
        optionTypeBill: Config.typeBill,
        optionStatusHis: Config.statusWarehouse,
        optionReason: [
          ...Config.reasonImportWarehouse,
          ...Config.reasonExport,
          ...Config.reasonTransferWarehouse,
        ],
        Config,
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return data
        }
        return dataReturn[0].text
      },
    },

    created() {
      this.fetchData()
    },

    methods: {
      backToList() {
        this.$router.push('/device')
      },
      transformColor(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].bgColor
      },
      changeLink(item) {
        /*
      if (item.type === 'TRANSFER' && item.reason === 'TRANSFER_AGENCY') {
        this.$router.push(`/transfer-agency-detail/${item.orderId}`)
        return
      }
      if (item.type === 'IMPORT')
        this.$router.push(`/import-warehouse/detail/${item.orderId}`)
      else if (item.type === 'EXPORT')
        this.$router.push(`/export-warehouse/${item.orderId}`)
      else if (item.type === 'TRANSFER')
        this.$router.push(`/transfer-warehouse/detail/${item.orderId}`)
      */
        switch (item.type) {
          case 'TRANSFER':
            if (item.reason === 'TRANSFER_AGENCY') {
              this.$router.push(`/transfer-agency-detail/${item.orderId}`)
            } else {
              this.$router.push(`/transfer-warehouse/detail/${item.orderId}`)
            }
            break
          case 'IMPORT':
            this.$router.push(`/import-warehouse/detail/${item.orderId}`)
            break
          case 'EXPORT':
            this.$router.push(`/export-warehouse/${item.orderId}`)
            break
          case 'USAGE_CHANGE':
            this.$router.push(`/usage-change/${item.orderId}`)
          default:
            break
        }
      },
      async warrantySuccess() {
        const { value: flag, note } = await this.rejectMx('Xác nhận bảo hành thành công')
        if (flag === true) {
          try {
            this.showLoading = true
            const res = await DeviceService.warrantySuccess({
              id: this.detail.id,
              note,
            })
            if (res.success === true) {
              this.fetchData()
              this.showSuccessMx('Xác nhận bảo hành thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            console.log(e)
          } finally {
            this.showLoading = false
          }
        }
      },

      async fetchData() {
        try {
          this.showLoading = true
          const data = await DeviceService.detailDevice({
            id: this.id,
          })
          if (data.success || data.code === 1000) {
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async reportLossDevice() {
        const { value: flag, note } = await this.rejectDeviceMx('Nhập mô tả lý do thất lạc')
        if (!flag) return
        try {
          const params = {
            id: this.id,
            note,
          }
          this.showLoading = true
          const data = await DeviceService.reportLossDevice(params)
          if (data.code === 1000) {
            this.showSuccessMx('Đã báo thất lạc thiết bị.')
            this.fetchData()
          } else {
            throw new Error(data.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      detailWarranty(id) {
        const routeData = this.$router.resolve({
          path: `/warranty/${id}`,
        })
        window.open(routeData.href, '_blank')
      },
    },
  }
</script>

<style scoped></style>
